<div class="flex items-center deal-activity-wrapper ">
    <div [class]="iconClass" class="flex items-center justify-center activity-icon mr-2">
        <mat-icon [class]="iconClass" class="material-icons-outlined history-icon">{{icon}}</mat-icon>
    </div>
    <div class="font-semibold">{{value()}}</div>
</div>
